import React from 'react'
import './information.css'

const Information = ({isVisible, actualyquestion, badquestion, skiped, maxQuestion }) => {
    if(!isVisible) return <></>;
    const left = maxQuestion - actualyquestion;
    return (
        <div className="info-container">
            <p className="info left">Pozostało: {left}</p>
            <p className="info bad">Odpowiedziano błędnie: {badquestion}</p>
            <p className="info skiped">Pominięto: {skiped}</p>
        </div>
    )
};
export default Information;